import keyMirror from '../../../utils/keyMirror';

export default keyMirror('BrickTile', 'Tile', 'LandscapeImage', 'Cell');
